/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_show = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit`
};

const da_show = /** @type {(inputs: {}) => string} */ () => {
	return `Vis`
};

const de_show = /** @type {(inputs: {}) => string} */ () => {
	return `Anzeigen`
};

const en_show = /** @type {(inputs: {}) => string} */ () => {
	return `Show`
};

const es_show = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar`
};

const fr_show = /** @type {(inputs: {}) => string} */ () => {
	return `Afficher`
};

const hu_show = /** @type {(inputs: {}) => string} */ () => {
	return `Megjelenítés`
};

const it_show = /** @type {(inputs: {}) => string} */ () => {
	return `Mostra`
};

const nl_show = /** @type {(inputs: {}) => string} */ () => {
	return `Tonen`
};

const pl_show = /** @type {(inputs: {}) => string} */ () => {
	return `Pokaż`
};

const pt_show = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar`
};

const sv_show = /** @type {(inputs: {}) => string} */ () => {
	return `Visa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const show = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.show(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("show", locale)
	if (locale === "cs") return cs_show(inputs)
	if (locale === "da") return da_show(inputs)
	if (locale === "de") return de_show(inputs)
	if (locale === "en") return en_show(inputs)
	if (locale === "es") return es_show(inputs)
	if (locale === "fr") return fr_show(inputs)
	if (locale === "hu") return hu_show(inputs)
	if (locale === "it") return it_show(inputs)
	if (locale === "nl") return nl_show(inputs)
	if (locale === "pl") return pl_show(inputs)
	if (locale === "pt") return pt_show(inputs)
	return sv_show(inputs)
};